import {
  Avatar,
  Box,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material"
import React, { useContext } from "react"
import { useState } from "react"
import TabPanel from "../components/ui/TabPanel"
import { AuthorizedFor } from "../components/common/AuthorizedFor"
import UserProfile from "../components/profile/UserProfile"
import NoticeBoard from "../components/profile/NoticeBoard"
import Approvals from "../components/profile/Approvals"
import AdmissionDetails from "../components/profile/AdmissionDetails"
import ContractDetails from "../components/profile/ContractDetails"
import roles from "../constants/roles"
import UserContext from "../contexts/user"

const Profile = () => {
  const { user } = useContext(UserContext)

  const [value, setValue] = useState(0)
  const handleChange = (_, newValue) => setValue(newValue)

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 0, sm: 10 },
        pl: 5,
        pt: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          alignItems: "center",
        }}
      >
        <Avatar sx={{ width: 120, height: 120 }}>{user.name[0]}</Avatar>
        <Box sx={{ textAlign: "center" }}>
          <Typography sx={{ mb: "10px" }} variant="h5">
            {user.name}
          </Typography>

          <Detail label="Email" value={user.email} />
          <Detail label="Phone" value={user.phone_number} />
        </Box>
      </Box>
      <Box sx={{ width: "100%" }}>
        <AuthorizedFor roles={[roles.STUDENT]}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab label="Profile" />
              <Tab label="Admission Details" />
              <Tab label="Notice Board" />
            </Tabs>
          </Box>
        </AuthorizedFor>
        <AuthorizedFor roles={[roles.TEACHER, roles.STAFF]}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab label="Profile" />
              <Tab label="Employment Details" />
              <Tab label="Notice Board" />
            </Tabs>
          </Box>
        </AuthorizedFor>
        <AuthorizedFor roles={[roles.ADMIN]}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab label="Profile" />
              <Tab label="Approvals" />
              <Tab label="Notice Board" />
            </Tabs>
          </Box>
        </AuthorizedFor>
        <TabPanel value={value} index={0}>
          <UserProfile user={user} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AuthorizedFor roles={[roles.STUDENT]}>
            <AdmissionDetails user={user} />
          </AuthorizedFor>
          <AuthorizedFor roles={[roles.TEACHER, roles.STAFF]}>
            <ContractDetails user={user} />
          </AuthorizedFor>
          <AuthorizedFor roles={[roles.ADMIN]}>
            <Approvals user={user} />
          </AuthorizedFor>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <NoticeBoard />
        </TabPanel>
      </Box>
    </Box>
  )
}

const Detail = ({ label, value }) => (
  <Stack direction="row" spacing={2} sx={{maxWidth: "14rem"}}>
    <Typography variant="body1" color="gray">
      {label}
    </Typography>
    <Typography variant="body1" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{value}</Typography>
  </Stack>
)

export default Profile
